import React from 'react'
import { Box } from '@usap/uicomponents'
import { TextWithPointer } from '../StyledCSS'
import Label from './Label'

const styleManager = {
  paddingLeft: { left: 'small' },
  marginBottom: { bottom: 'small' },
  textDecoration: { textDecoration: 'underline', marginTop: 8 },
}

export default function CustomAnchorContainer({
  labelContainerWidth,
  labelMargin,
  firstLabelText,
  selectedVehicle,
  vehicleString,
  addVehicleTrigger,
  orderItemId,
  specialPLAVehicleSelector,
  specialPLAVehicleText,
  hideVehicleModifyLink,
}) {
  return (
    <Box
      pad={styleManager.paddingLeft}
      align="start"
      justify="center"
      {...labelContainerWidth}
    >
      <Label {...labelMargin}>{firstLabelText}</Label>
      {selectedVehicle && <Label size="small">{vehicleString}</Label>}
      {specialPLAVehicleText && (
        <Label size="small">
          {specialPLAVehicleText}
        </Label>
      )}
      {addVehicleTrigger && !hideVehicleModifyLink && (
        <TextWithPointer
          fxSize={{ large: '14px', other: '12px' }}
          color="blueLink"
          weight={700}
          style={styleManager.textDecoration}
          onClick={() => addVehicleTrigger(orderItemId, specialPLAVehicleSelector ? 'add' : 'change')}
        >
          {specialPLAVehicleSelector
            ? 'Add Vehicle Information'
            : 'Add Vehicle'}
        </TextWithPointer>
      )}
    </Box>
  )
}
